import React from "react";

import {
  BaseComponent,
  IBasicHtml,
  IBasicText,
  IIconRow,
  IIcon,
  ILink,
  IBasicMedia,
  ILinkList,
  ISiteSearch,
  EventCallback,
  IFullCard
} from "../../../interfaces";
import { COMPONENTS } from "../../../constants";
import CssOverride from "../../css-override";
import { CmsLink, LinkList } from "../../links";
import { Icon, IconRow } from "../../icons";
import Card from "../../card";
import { CmsHtml, CmsMarkdown, CmsMedia } from "../../basic";
import SiteSearch from "../../site-search";

interface Props {
  component: BaseComponent;
  events?: { [key: string]: EventCallback };
}

class ComponentBroker extends React.Component<Props, {}> {
  FormattedComponent;

  constructor(props) {
    super(props);

    const { component, events } = this.props;
    const componentType = component.__typename || component.component;

    switch (componentType) {
      case COMPONENTS.HTML:
        this.FormattedComponent = CssOverride(CmsHtml, component as IBasicHtml);
        break;
      case COMPONENTS.MARKDOWN:
        this.FormattedComponent = CssOverride(CmsMarkdown, component as IBasicText, {
          content: component
        });
        break;
      case COMPONENTS.SNIPPET_MARKDOWN:
        this.FormattedComponent = CssOverride(CmsMarkdown, component as IBasicText, {
          content: component
        });
        break;
      case COMPONENTS.LINK:
        this.FormattedComponent = CssOverride(CmsLink, component as ILink);
        break;
      case COMPONENTS.SNIPPET_LINK:
        this.FormattedComponent = CssOverride(CmsLink, component as ILink);
        break;
      case COMPONENTS.MEDIA:
      case COMPONENTS.SNIPPET_MEDIA:
        const props = { ...component, ...events };

        this.FormattedComponent = CssOverride(CmsMedia, props as IBasicMedia);
        break;
      case COMPONENTS.LINK_LIST:
        this.FormattedComponent = CssOverride(LinkList, component as ILinkList);
        break;
      case COMPONENTS.ICON:
        this.FormattedComponent = CssOverride(Icon, component as IIcon);
        break;
      case COMPONENTS.ICON_ROW:
        this.FormattedComponent = CssOverride(IconRow, component as IIconRow);
        break;
      case COMPONENTS.SITE_SEARCH:
        this.FormattedComponent = CssOverride(SiteSearch, component as ISiteSearch);
        break;
      case COMPONENTS.FULL_CARD:
        this.FormattedComponent = CssOverride(Card, component as IFullCard);
        break;
      case COMPONENTS.CUSTOM_DATA:
        this.FormattedComponent = <div></div>;
        break;
      default:
        throw new Error(`${component.__typename} does not exist.`);
    }
  }

  render() {
    return <this.FormattedComponent />;
  }
}

export default ComponentBroker;
